// extracted by mini-css-extract-plugin
export default {"action-link":"aSXiisabdeNtOEU4ZBki","endpoint-details":"DQfS8Vgutr9neZRvEVIc"};